<template>
    <div>
        <div class="page- row mb15">
            <div class="col-md-9">
                <h2 class="mt15 text-uppercase ">{{client.fullName}}</h2>
                {{client.comment}}
            </div>

            <div class="col-md-3">


              <div class="panel panel-tile text-info br-b bw5 br-info-light">
                <div class="panel-body pl20 p5">
                  <i class="fa fa-certificate icon-bg"></i>
                  <h2 class="mt15 lh15" :title="client.getSubStatusName() || ''">
                    <b>{{client.getStatusName() || '---'}}</b>
                  </h2>
                  <h5 class="text-muted">Статус</h5>
                </div>
              </div>

            </div>
        </div>

        <tabs>
            <tab title="Основное">
                <div class="row">
                    <div class="col-md-6 tab-pane ">
                        <form @submit.prevent="submit">
                            <div class="panel">
                                <div class="panel-heading">
                            <span class="panel-title text-uppercase">
                                <i class="fa fa-pencil-square"></i>
                                Профиль
                            </span>
                                </div>
                                <div class="admin-form theme-primary">
                                    <div class="panel-body p25">

                                        <div class="section row">
                                            <div class="col-md-6">
                                                <label class="field-label">Имя</label>
                                                <label class="field prepend-icon">
                                                    <input type="text" v-model="$v.client.firstName.$model" class="gui-input"
                                                           autocomplete="off">
                                                    <label class="field-icon"><i class="fa fa-tag"></i></label>
                                                </label>
                                                <div v-if="$v.client.firstName.$error === true || forms.client.errors.first_name" class="error">
                                                    {{ this.forms.client.errors.first_name ? this.forms.client.errors.first_name.join(', ') : 'Введите верное значение' }}
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="field-label">Фамилия</label>
                                                <label class="field prepend-icon">
                                                    <input type="text" v-model="$v.client.lastName.$model" class="gui-input"
                                                           autocomplete="off">
                                                    <label class="field-icon"><i class="fa fa-tag"></i></label>
                                                </label>
                                                <div v-if="$v.client.lastName.$error === true || forms.client.errors.last_name" class="error">
                                                    {{ this.forms.client.errors.last_name ? this.forms.client.errors.last_name.join(', ') : 'Введите верное значение' }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="section row">
                                            <div class="col-md-6">

                                                <label class="field-label">Телефон</label>
                                                <label class="field prepend-icon">
                                                    <input v-model="$v.client.phone.$model" type="tel" class="gui-input"
                                                           placeholder="+7925">
                                                    <label class="field-icon">
                                                        <i class="fa fa-phone-square"></i>
                                                    </label>
                                                </label>
                                                <div v-if="$v.client.phone.$error === true || forms.client.errors.phone" class="error">
                                                    {{ this.forms.client.errors.phone ? this.forms.client.errors.phone.join(', ') : 'Введите верное значение' }}
                                                </div>
                                            </div>
                                            <div class="col-md-6">

                                                <label class="field-label">Email</label>
                                                <label class="field prepend-icon">
                                                    <input v-model="$v.client.email.$model" type="email" class="gui-input"
                                                           placeholder="example@domain.com...">
                                                    <label class="field-icon">
                                                        <i class="fa fa-envelope"></i>
                                                    </label>
                                                </label>
                                                <div v-if="$v.client.email.$error === true || forms.client.errors.email" class="error">
                                                    {{ this.forms.client.errors.email ? this.forms.client.errors.email.join(', ') : 'Введите верное значение' }}
                                                </div>
                                            </div>
                                            <!-- end section -->

                                        </div>
                                        <div class="section row">
                                            <div class="col-md-6">
                                                <label class="field-label">Источник</label>
                                                <label class="field select">
                                                    <select
                                                        v-model="$v.client.source.$model"
                                                        :disabled="client.source === 7 || client.source === 8"
                                                    >
                                                        <option value="0" disabled="">Выберите источник</option>
                                                        <option
                                                                v-for="source in data.sources"
                                                                v-bind:key="source.id"
                                                                :value="source.id"
                                                                :disabled="sourceIsDisabled(source.id)"
                                                        >
                                                            {{source.name}}
                                                        </option>
                                                    </select>
                                                    <i class="arrow double"></i>
                                                </label>
                                                <div v-if="$v.client.source.$error === true || forms.client.errors.source" class="error">
                                                    {{ this.forms.client.errors.source ? this.forms.client.errors.source.join(', ') : 'Выберите значение' }}
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="field-label">Дата рождения</label>
                                                <label class="field">
                                                    <date-picker value-type="format" format="DD.MM.YYYY" v-model="clientBirthday" :clearable="false"/>
                                                </label>
                                                <div v-if="$v.client.birthday.$error === true || forms.client.errors.birthday" class="error">
                                                    {{ this.forms.client.errors.birthday ? this.forms.client.errors.birthday.join(', ') : 'Введите верное значение' }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="section row mb25">
                                            <div class="col-md-12">

                                                <label class="field-label">Статус</label>
                                                <label class="field">
                                                    <input disabled readonly type="text" class="gui-input" :value="clientStatusName">
                                                </label>
                                            </div>
                                        </div>
                                        <div class="section row mb25">
                                            <div class="col-md-12">
                                                <label class="field-label">Ответственный</label>
                                                <label class="field select">
                                                    <select v-model="$v.client.responsibleId.$model">
                                                        <option value="0">Нет</option>
                                                        <option v-for="user in data.users" v-bind:key="user.id" :value="user.id">
                                                            {{user.fullName}}
                                                        </option>
                                                    </select>
                                                    <i class="arrow double"></i>
                                                </label>
                                                <div v-if="$v.client.responsibleId.$error === true || forms.client.errors.responsible_id" class="error">
                                                    {{ this.forms.client.errors.responsible_id ? this.forms.client.errors.responsible_id.join(', ') : 'Введите верное значение' }}
                                                </div>
                                            </div>
                                        </div>
                                      <div class="section row mb25">
                                        <div class="col-md-12">
                                          <label class="field-label">Менеджер</label>
                                          <label class="field select">
                                            <select v-model="$v.client.managerId.$model">
                                              <option value="0">Нет</option>
                                              <option v-for="post in data.posts" v-bind:key="post.id" :value="post.id">
                                                {{post.name}}
                                              </option>
                                            </select>
                                            <i class="arrow double"></i>
                                          </label>
                                          <div v-if="$v.client.managerId.$error === true || forms.client.errors.manager_id" class="error">
                                            {{ this.forms.client.errors.manager_id ? this.forms.client.errors.manager_id.join(', ') : 'Введите верное значение' }}
                                          </div>
                                        </div>
                                      </div>
                                        <div class="section row mb25">
                                            <div class="col-md-12">
                                                <label class="switch switch-primary">
                                                    <input type="checkbox" id="form-client-sms-notification" v-model="$v.client.smsNotification.$model" value="1">
                                                    <label for="form-client-sms-notification" data-on="Да" data-off="Нет"></label>
                                                    <span>Получает SMS уведомления</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="section row mb25">
                                            <div class="col-md-6">
                                                <label class="switch switch-primary">
                                                    <input type="checkbox" id="form-client-is-archive" v-model="$v.client.isArchive.$model" value="1">
                                                    <label for="form-client-is-archive" data-on="Да" data-off="Нет"></label>
                                                    <span>Архивный</span>
                                                </label>
                                            </div>
                                        </div>

                                      <div class="section row mb25">
                                        <div class="col-md-6">
                                          <label class="switch switch-primary">
                                            <input type="checkbox" id="form-client-is-corp" v-model="$v.client.isCorp.$model" value="1">
                                            <label for="form-client-is-corp" data-on="Да" data-off="Нет"></label>
                                            <span>Имеет корпоративную скидку</span>
                                          </label>
                                        </div>
                                      </div>

                                        <div class="section row mb25">
                                            <div class="col-md-12">
                                                <label class="field-label">Комментарий</label>
                                                <label class="field prepend-icon">
                                                    <textarea class="gui-textarea" v-model="$v.client.comment.$model"></textarea>
                                                    <label class="field-icon">
                                                        <i class="fa fa-edit"></i>
                                                    </label>
                                                </label>
                                            </div>
                                        </div>


                                    </div>

                                    <div class="panel-footer">
                                        <button type="submit" class="button btn-primary" :disabled="forms.client.isSubmitting">
                                            <span>Сохранить</span>
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>

                    <div class="col-md-6">
                        <cards :client="client"/>

                        <subscriptions :client="client" show-actions/>

                        <debts :client="client"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="panel ">
                            <div class="panel-heading">
                                <span class="panel-title">Продажи</span>
                            </div>

                            <div class="panel-body">
                                <table class="table table-striped table-hover ">
                                    <thead>
                                    <th> № продажи</th>
                                    <th> Операция </th>
                                    <th> Абонемент</th>
                                    <th> Тип платежа </th>
                                    <th> Стоимость </th>
                                    <th> Скидка </th>
                                    <th> Внесено </th>
                                    <th> Сдача </th>
                                    <th> Время </th>
                                    <th> Дата </th>
                                    <th> Принял </th>
                                    </thead>
                                    <tbody>
                                    <tr v-for="cashflow in client.sales" v-bind:key="cashflow.id">
                                        <td>{{cashflow.id}}</td>
                                        <td>{{cashflow.typeId ? data.types.find(type => type.id === cashflow.typeId).name : 'Другое'}}</td>
                                        <td>{{cashflow.link ? cashflow.link.name : '---' }}</td>
                                        <td>{{data.paymentTypes.find(type => type.id === cashflow.paymentType).name}}</td>
                                        <td class="sum-cell">{{cashflow.sum | numberFormat(0)}}</td>
                                        <td class="sum-cell">{{cashflow.discount | numberFormat(0)}}%</td>
                                        <td class="sum-cell">{{cashflow.sumIn | numberFormat(0)}}</td>
                                        <td class="sum-cell">{{cashflow.sumChange | numberFormat(0)}}</td>
                                        <td>{{cashflow.createdAt | dateFormatTimestamp('HH:MM:ss')}}</td>
                                        <td>{{cashflow.createdAt | dateFormatTimestamp('dd.mm.yyyy')}}</td>
                                        <td>{{cashflow.creator ? cashflow.creator.fullName : '---'}}</td>
                                    </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>

                    </div>
                </div>
            </tab>
            <tab title="Посещения">
                <div class="panel">
                    <loading :active.sync="visits.isLoading" color="#4c4a49" :is-full-page="false"/>
                    <div class="panel-body pn">
                        <per-pager v-bind:per-page="visits.pagination.perPage" query-name="visits-per-page"/>
                        <table class="table table-striped table-hover datatables" id="clients_list">
                            <thead>
                            <tr>
                                <th>№ визита</th>
                                <th>Событие</th>
                                <th>Абонемент</th>
                                <th>Инструктор</th>
                                <th>Дата</th>
                                <th>Дата регистрации</th>
                                <th>Автор</th>
                            </tr>
                            </thead>
                            <tbody v-for="subscribe in visitsBySubscribe" v-bind:key="subscribe.id">

                                <tr class="group row-label">
                                    <td colspan="7">№{{subscribe.id}} - {{subscribe.subscription.name}}</td>
                                </tr>
                                <tr v-for="visit in subscribe.visits" v-bind:key="visit.id">
                                    <td>{{visit.id}}</td>
                                    <td>
                                        <span v-if="visit.direction && visit.schedule">
                                            {{visit.direction.name}} с {{visit.schedule.time_start}} по {{visit.schedule.time_end}}
                                        </span>
                                        <span v-else>---</span>
                                    </td>
                                    <td>{{visit.subscription ? visit.subscription.name : '---'}}</td>
                                    <td>{{visit.trainer ? visit.trainer.fullName : '---'}}</td>
                                    <td>{{visit.date | moment('DD.MM.YYYY')}}</td>
                                    <td>{{visit.createdAt | dateFormatTimestamp('dd.mm.yyyy HH:MM:ss')}}</td>
                                    <td>{{visit.creator ? visit.creator.fullName : '---'}}</td>
                                </tr>

                            </tbody>
                            <tbody v-show="visitsBySubscribe.length === 0">
                                <tr>
                                    <td colspan="7" class="text-center">Нет посещений</td>
                                </tr>
                            </tbody>
                        </table>
                        <paginator v-bind="visits.pagination" query-name="visits-page"/>

                    </div>
                </div>
            </tab>
            <tab title="Бронирования">
                <div class="panel">
                    <loading :active.sync="reservations.isLoading" color="#4c4a49" :is-full-page="false"/>
                    <div class="panel-body pn">
                        <per-pager v-bind:per-page="reservations.pagination.perPage" query-name="reservations-per-page"/>
                        <table class="table table-striped table-hover datatables" id="reservations_list">
                            <thead>
                            <tr>
                                <th>№ визита</th>
                                <th>Событие</th>
                                <th>Инструктор</th>
                                <th>Дата</th>
                                <th>Дата регистрации</th>
                                <th>Автор</th>
                            </tr>
                            </thead>
                            <tbody>

                                <tr v-for="visit in reservations.reservations" v-bind:key="visit.id">
                                    <td>{{visit.id}}</td>
                                    <td>
                                        <span v-if="visit.direction && visit.schedule">
                                            {{visit.direction.name}} с {{visit.schedule.time_start}} по {{visit.schedule.time_end}}
                                        </span>
                                        <span v-else>---</span>
                                    </td>
                                    <td>{{visit.trainer ? visit.trainer.fullName : '---'}}</td>
                                    <td>{{visit.date | moment('DD.MM.YYYY')}}</td>
                                    <td>{{visit.createdAt | dateFormatTimestamp('dd.mm.yyyy HH:MM:ss')}}</td>
                                    <td>{{visit.creator ? visit.creator.fullName : '---'}}</td>
                                </tr>

                            </tbody>
                            <tbody v-show="reservations.reservations.length === 0">
                                <tr>
                                    <td colspan="6" class="text-center">Нет бронирований</td>
                                </tr>
                            </tbody>
                        </table>
                        <paginator v-bind="reservations.pagination" query-name="reservations-page"/>

                    </div>
                </div>
            </tab>
            <tab title="Статусы">
                <div class="row">
                    <div class="admin-form theme-primary">
                        <div class="col-md-12 tab-pane">
                            <div class="panel">
                                <loading :active.sync="forms.status.isLoading" color="#4c4a49" :is-full-page="false"/>
                                <div class="panel-body p25">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <label class="field-label">Установить статус</label>
                                            <label class="field">
                                                <vue-select
                                                        :options="[{id: 3, name: 'Позвонить'}, {id: 4, name: 'Больше не звонить'}]"
                                                        v-model="forms.status.status"
                                                        :searchable="false"
                                                        :clearable="false"
                                                        :reduce="option => option.id"
                                                        label="name"
                                                        class="filter-form-select-full-width"
                                                />
                                            </label>
                                        </div>
                                        <div class="col-md-6" v-if="forms.status.status === 3">
                                            <label class="field-label">Дата звонка</label>
                                            <label class="field prepend-icon">
                                                <input v-model="forms.status.date" type="date" class="gui-input">
                                                <label class="field-icon">
                                                    <i class="fa fa-calendar"></i>
                                                </label>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="panel-footer">
                                    <button type="button" v-on:click="setStatus" class="button btn-primary" :disabled="forms.status.isLoading">
                                        <span>Изменить статус</span>
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel">
                    <loading :active.sync="statusHistory.isLoading" color="#4c4a49" :is-full-page="false"/>
                    <div class="panel-body pn">
                        <per-pager v-bind:per-page="statusHistory.pagination.perPage" query-name="status-per-page"/>
                        <table class="table table-striped table-hover datatables">
                            <thead>
                            <tr>
                                <th>id</th>
                                <th>Статус</th>
                                <th></th>
                                <th>Дата изменения</th>
                            </tr>
                            </thead>
                            <tbody>

                            <tr v-for="status in statusHistory.statuses" v-bind:key="status.id">
                                <td>{{status.id}}</td>
                                <td>{{status.statusName}}</td>
                                <td>{{status.subStatusName}}</td>
                                <td>{{status.createdAt | dateFormatTimestamp('dd.mm.yyyy HH:MM:ss')}}</td>
                            </tr>

                            <tr v-show="statusHistory.statuses.length === 0">
                                <td colspan="4" class="text-center">Нет истории статусов</td>
                            </tr>

                            </tbody>
                        </table>
                        <paginator v-bind="statusHistory.pagination" query-name="status-page"/>

                    </div>
                </div>
            </tab>
            <tab title="Сообщения">
                <div class="panel">
                    <loading :active.sync="sms.isLoading" color="#4c4a49" :is-full-page="false"/>
                    <div class="panel-body pn">
                        <per-pager v-bind:per-page="sms.pagination.perPage" query-name="sms-per-page"/>
                        <table class="table table-striped table-hover datatables">
                            <thead>
                            <tr>
                                <th>id</th>
                                <th>Номер</th>
                                <th>Текст</th>
                                <th>ID провайдера</th>
                                <th>Статус отправки</th>
                                <th>Дата отправки</th>
                                <th>Автор</th>
                            </tr>
                            </thead>
                            <tbody>

                            <tr v-for="sms in sms.sms" v-bind:key="sms.id">
                                <td>{{sms.id}}</td>
                                <td>{{sms.phone}}</td>
                                <td>{{sms.content}}</td>
                                <td>{{sms.outerId ? sms.outerId : '---'}}</td>
                                <td>{{sms.status === 1 ? 'Отправлено' : 'Отказ'}}</td>
                                <td>{{sms.createdAt | dateFormatTimestamp('dd.mm.yyyy HH:MM:ss')}}</td>
                                <td>{{sms.creator ? sms.creator.fullName : '---'}}</td>
                            </tr>

                            <tr v-show="sms.sms.length === 0">
                                <td colspan="7" class="text-center">Нет сообщений</td>
                            </tr>

                            </tbody>
                        </table>
                        <paginator v-bind="sms.pagination" query-name="sms-page"/>

                    </div>
                </div>
            </tab>
            <tab title="Изменения профиля">
                <div class="panel">
                    <loading :active.sync="history.isLoading" color="#4c4a49" :is-full-page="false"/>
                    <div class="panel-body pn">
                        <per-pager v-bind:per-page="history.pagination.perPage" query-name="history-per-page"/>
                        <table class="table table-striped table-hover datatables">
                            <thead>
                            <tr>
                                <th>id</th>
                                <th>Модуль</th>
                                <th>Событие</th>
                                <th>Поля</th>
                                <th>Время</th>
                                <th>Дата</th>
                                <th>Автор</th>
                            </tr>
                            </thead>
                            <tbody v-for="row in history.history" v-bind:key="row.id">

                                <tr
                                        v-on:click="showHistory(row.id)"
                                        :class="{
                                            'primary': history.openHistory.some(id => id === row.id),
                                        }"
                                        class="row-select"
                                >
                                    <td>{{row.id}}</td>
                                    <td>{{row.table}}</td>
                                    <td>{{row.type === 1 ? 'Создание' : 'Редактирование'}}</td>
                                    <td>
                                        <span v-for="(value, field, index) of row.data" class="tm-tag tm-tag-primary" v-bind:key="index">
                                            <span>{{field}}</span>
                                        </span>
                                    </td>
                                    <td>{{history.createdAt | dateFormatTimestamp('HH:MM:ss')}}</td>
                                    <td>{{history.createdAt | dateFormatTimestamp('dd.mm.yyyy')}}</td>
                                    <td>{{history.creator ? history.creator.fullName : '---'}}</td>
                                </tr>
                                <tr v-show="history.openHistory.some(id => id === row.id)">
                                    <td colspan="7">
                                        <div v-for="(oldValue, field) of row.data" v-bind:key="row.id + field">
                                            <span class="label label-info">{{field}}</span><span class="label label-warning">=</span><span class="label label-danger">{{oldValue ? oldValue : '---'}}</span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                            <tr v-show="history.history.length === 0">
                                <td colspan="7" class="text-center">Нет изменений</td>
                            </tr>

                            </tbody>
                        </table>
                        <paginator v-bind="history.pagination" query-name="history-page"/>

                    </div>
                </div>
            </tab>

            <tab title="Отправить сообщение">
                <div class="panel">
                    <div class="panel-body">
                        <form v-on:submit.prevent="smsSend">
                            <div class=" admin-form">
                                <div class="panel">
                                    <div class="panel-body p25">
                                        <div class="section">
                                            <label class="field prepend-icon">
                                                <textarea class="gui-textarea" v-model.trim="forms.sms.text" maxlength="60" placeholder="60 символов"></textarea>
                                                <label class="field-icon">
                                                    <i class="fa fa-comments"></i>
                                                </label>
                                                <span class="input-footer">
                                                    <strong>Ограничение:</strong> 60 символов. Все отправленные смс сохраняются в базе.
                                                </span>
                                            </label>
                                        </div>

                                    </div>
                                    <div class="panel-footer">
                                        <button type="submit" class="btn btn-primary sendsms" :disabled="forms.sms.isSubmitting">Отправить</button>
                                    </div>
                                </div>
                            </div>
                        </form>

                    </div>
                </div>
            </tab>
        </tabs>
    </div>
</template>

<script>
    import Client from "../../models/Client";
    import { required } from 'vuelidate/lib/validators';
    import { validationMixin } from 'vuelidate';
    import Cashflow from "../../models/Cashflow";
    import Visit from "../../models/Visit";
    import Sms from "../../models/Sms";
    import ClientStatus from "../../models/ClientStatus";
    import { Tabs, Tab } from 'vue-slim-tabs'
    import SmsApi from '../../classes/api/Sms';
    import History from '../../models/History';
    import moment from 'moment';
    import User from "@/models/User";
    import UserPost from "@/models/UserPost";
    import ClientHistory from '@/models/v2/ClientHistory'

    export default {
        components: {
            datePicker: () => import('vue2-datepicker'),
            vueSelect: () => import('vue-select'),
            cards: () => import('./Cards'),
            subscriptions: () => import('./Subscriptions'),
            debts: () => import('./Debts'),
            tabs: Tabs,
            tab: Tab,
            Loading: () => import('vue-loading-overlay'),
            Paginator: () => import('../data/Paginator'),
            PerPager: () => import('../data/PerPager'),
        },
        mixins: [validationMixin],
        async beforeRouteEnter(to, from, next) {
            try {
                const client = await Client.get(to.params.id);
                next(component => {
                    User.getList(1, 999).then(({data}) => {
                        component.data.users = data;
                    });
                    UserPost.getList(1, 999).then(({data}) => {
                      component.data.posts = data;
                    });
                    console.log(component.data.posts);
                    component.client = client;
                    component.clientBirthday = moment(client.birthday, 'YYYY-MM-DD').format('DD.MM.YYYY');
                    component.getVisits();
                    component.getReservations();
                    component.getHistory();
                    component.getSms();
                    component.getStatusHistory();
                    component.getClientHistory();
                });
            } catch (error) {
                next({
                    name: 'error',
                    path: to.fullPath,
                    params: {
                        code: error.response.status,
                        codeText: error.response.statusText,
                        message: error.response.data.message,
                        trace: error.response.data.type,
                    },
                })
            }

        },
        computed: {
            visitsBySubscribe: function() {
                let result = [];

                for (let visit of this.visits.visits) {
                    let index = result.findIndex(res => visit.subscriptionClient.id === res.id);
                    if (index === -1) {
                        visit.subscriptionClient.subscription = visit.subscription;
                        index = result.push(visit.subscriptionClient) - 1;
                        result[index].visits = [];
                    }
                    result[index].visits.push(visit);
                }
                return result;
            },
            clientStatusName: function() {
                if (!this.client.status) {
                    return '';
                }
                const statuses = ClientStatus.getStatuses();
                const status = statuses.find(element => element.id === this.client.status);

                return status ? status.name : '';
            },
        },
        watch: {
            '$route.query' (newValue, oldValue) {
                if (this.checkListUpdate('visits', newValue, oldValue) === true) {
                    this.getVisits();
                }
                if (this.checkListUpdate('reservations', newValue, oldValue) === true) {
                    this.getReservations();
                }
                if (this.checkListUpdate('history', newValue, oldValue) === true) {
                    this.getHistory();
                }
                if (this.checkListUpdate('sms', newValue, oldValue) === true) {
                    this.getSms();
                }
                if (this.checkListUpdate('status', newValue, oldValue) === true) {
                    this.getStatusHistory();
                }
                if (this.checkListUpdate('client-history', newValue, oldValue) === true) {
                    this.getClientHistory();
                }
            },
        },
        data() {
            return {
                data: {
                    sources: Client.getSources(),
                    users: [],
                    posts: [],
                    paymentTypes: Cashflow.getTypesPayment(),
                    types: Cashflow.getTypes(),
                },
                visits: {
                    isLoading: false,
                    visits: [],
                    pagination: {
                        currentPage: 0,
                        pageCount: 0,
                        perPage: 0,
                        totalCount: 0,
                    },
                },
                reservations: {
                    isLoading: false,
                    reservations: [],
                    pagination: {
                        currentPage: 0,
                        pageCount: 0,
                        perPage: 0,
                        totalCount: 0,
                    },
                },
                history: {
                    openHistory: [],
                    isLoading: false,
                    history: [],
                    pagination: {
                        currentPage: 0,
                        pageCount: 0,
                        perPage: 0,
                        totalCount: 0,
                    },
                },
                clientHistory: {
                    isLoading: false,
                    clientHistory: [],
                    pagination: {
                        currentPage: 0,
                        pageCount: 0,
                        perPage: 0,
                        totalCount: 0,
                    },
                },
                sms: {
                    isLoading: false,
                    sms: [],
                    pagination: {
                        currentPage: 0,
                        pageCount: 0,
                        perPage: 0,
                        totalCount: 0,
                    },
                },
                statusHistory: {
                    isLoading: false,
                    statuses: [],
                    pagination: {
                        currentPage: 0,
                        pageCount: 0,
                        perPage: 0,
                        totalCount: 0,
                    },
                },
                client: new Client({source: 0, smsNotification: 1}),
                clientBirthday: '',
                forms: {
                    client: {
                        isSubmitting: false,
                        errors: {},
                    },
                    sms: {
                        isSubmitting: false,
                        text: '',
                    },
                    status: {
                        isLoading: false,
                        status: 3,
                        date: null,
                    },
                },
            };
        },
        validations: {
            client: {
                firstName: {required},
                lastName: {},
                phone: {required},
                birthday: {},
                email: {},
                source: {},
                comment: {},
                responsibleId: {},
                managerId: {},
                isArchive: {},
                isCorp: {},
                smsNotification: {},
            },
            forms: {
                sms: {
                    text: {required},
                },
            },
        },
        methods: {
            checkListUpdate(type, newValue, oldValue) {
                if (newValue[type + '-page'] && newValue[type + '-page'] != oldValue[type + '-page']) {
                    return true;
                }
                if (newValue[type + '-per-page'] && newValue[type + '-per-page'] != oldValue[type + '-per-page']) {
                    return true;
                }

                return false;
            },
            sourceIsDisabled (id) {
                if (this.client.source === Client.SOURCE_GOOGLE_UTM || this.client.source === Client.SOURCE_YANDEX_UTM) {
                    return true;
                }
                if (id === Client.SOURCE_GOOGLE_UTM || id === Client.SOURCE_YANDEX_UTM) {
                    return true;
                }

                return false;
            },
            async submit() {
                this.$v.client.$touch();
                if (this.$v.client.$invalid) {
                    return false;
                }

                this.forms.client.isSubmitting = true;
                this.forms.client.errors = {};


                try {
                    if (this.clientBirthday) {
                        this.client.birthday = moment(this.clientBirthday, 'DD.MM.YYYY').format('YYYY-MM-DD');
                    }
                    await this.client.update();
                } catch (error) {
                    this.forms.client.errors = error.errors;
                }

                this.forms.client.isSubmitting = false;
            },
            async getVisits() {
                this.visits.isLoading = true;
                const page = this.$route.query['visits-page'] ? this.$route.query['visits-page'] : 1;
                const perPage = this.$route.query['visits-per-page'] ? this.$route.query['visits-per-page'] : 100;

                const {data, headers} = await Visit.getList(
                    page,
                    perPage,
                    '-id',
                    ['trainer', 'subscription', 'subscriptionClient', 'schedule', 'direction', 'creator'],
                    {client_id: this.$route.params.id, is_reservation: 0}
                );

                this.visits.visits = data;
                this.visits.pagination.currentPage = Number(headers['x-pagination-current-page']);
                this.visits.pagination.pageCount = Number(headers['x-pagination-page-count']);
                this.visits.pagination.perPage = Number(headers['x-pagination-per-page']);
                this.visits.pagination.totalCount = Number(headers['x-pagination-total-count']);
                this.visits.isLoading = false;
            },
            async getReservations() {
                this.reservations.isLoading = true;
                const page = this.$route.query['reservations-page'] ? this.$route.query['reservations-page'] : 1;
                const perPage = this.$route.query['reservations-per-page'] ? this.$route.query['reservations-per-page'] : 100;

                const {data, headers} = await Visit.getList(
                    page,
                    perPage,
                    '-id',
                    ['trainer', 'subscription', 'subscriptionClient', 'schedule', 'direction', 'creator'],
                    {client_id: this.$route.params.id, is_reservation: 1}
                );

                this.reservations.reservations = data;
                this.reservations.pagination.currentPage = Number(headers['x-pagination-current-page']);
                this.reservations.pagination.pageCount = Number(headers['x-pagination-page-count']);
                this.reservations.pagination.perPage = Number(headers['x-pagination-per-page']);
                this.reservations.pagination.totalCount = Number(headers['x-pagination-total-count']);
                this.reservations.isLoading = false;
            },
            async getHistory() {
                this.history.isLoading = true;
                const page = this.$route.query['history-page'] ? this.$route.query['history-page'] : 1;
                const perPage = this.$route.query['history-per-page'] ? this.$route.query['history-per-page'] : 10;

                const {data, headers} = await History.getList(
                    this.$route.params.id,
                    ['client', 'client_cards'],
                    page,
                    perPage,
                    '-id',
                    ['creator']
                );

                this.history.history = data;
                this.history.pagination.currentPage = Number(headers['x-pagination-current-page']);
                this.history.pagination.pageCount = Number(headers['x-pagination-page-count']);
                this.history.pagination.perPage = Number(headers['x-pagination-per-page']);
                this.history.pagination.totalCount = Number(headers['x-pagination-total-count']);
                this.history.isLoading = false;
            },
            async getClientHistory() {
                this.clientHistory.isLoading = true;
                const page = this.$route.query['client-history-page'] ? this.$route.query['client-history-page'] : 1;
                const perPage = this.$route.query['client-history-per-page'] ? this.$route.query['client-history-per-page'] : 10;

                const {data, headers} = await ClientHistory.getList(
                    this.$route.params.id,
                    page,
                    '-created_at,-link_id',
                    perPage,
                    ['creator']
                );

                this.clientHistory.clientHistory = data;
                this.clientHistory.pagination.currentPage = Number(headers['x-pagination-current-page']);
                this.clientHistory.pagination.pageCount = Number(headers['x-pagination-page-count']);
                this.clientHistory.pagination.perPage = Number(headers['x-pagination-per-page']);
                this.clientHistory.pagination.totalCount = Number(headers['x-pagination-total-count']);
                this.clientHistory.isLoading = false;
            },
            async getStatusHistory() {
                this.statusHistory.isLoading = true;
                const page = this.$route.query['status-page'] ? this.$route.query['status-page'] : 1;
                const perPage = this.$route.query['status-per-page'] ? this.$route.query['status-per-page'] : 10;

                const {data, headers} = await ClientStatus.getList(
                    this.$route.params.id,
                    page,
                    perPage,
                    '-id',
                );

                this.statusHistory.statuses = data;
                this.statusHistory.pagination.currentPage = Number(headers['x-pagination-current-page']);
                this.statusHistory.pagination.pageCount = Number(headers['x-pagination-page-count']);
                this.statusHistory.pagination.perPage = Number(headers['x-pagination-per-page']);
                this.statusHistory.pagination.totalCount = Number(headers['x-pagination-total-count']);
                this.statusHistory.isLoading = false;
            },
            async getSms() {
                this.sms.isLoading = true;
                const page = this.$route.query['sms-page'] ? this.$route.query['sms-page'] : 1;
                const perPage = this.$route.query['sms-per-page'] ? this.$route.query['sms-per-page'] : 10;

                const {data, headers} = await Sms.getList(
                    this.$route.params.id,
                    page,
                    perPage,
                    '-id',
                    ['creator']
                );

                this.sms.sms = data;
                this.sms.pagination.currentPage = Number(headers['x-pagination-current-page']);
                this.sms.pagination.pageCount = Number(headers['x-pagination-page-count']);
                this.sms.pagination.perPage = Number(headers['x-pagination-per-page']);
                this.sms.pagination.totalCount = Number(headers['x-pagination-total-count']);
                this.sms.isLoading = false;
            },
            async smsSend() {
                this.$v.forms.sms.$touch();
                if (this.$v.forms.sms.$invalid) {
                    return false;
                }

                this.forms.sms.isSubmitting = true;


                let isError = false;
                try {
                    let response = await SmsApi.clientSend(this.client.id, this.forms.sms.text);
                    this.forms.sms.text = '';

                    if (response.data.success === true) {
                        this.$notify({
                            text: 'Сообщение отправлено',
                        });
                        this.getSms();
                    } else {
                        isError = true;
                    }
                } catch (error) {
                    isError = true;
                }

                if (isError === true) {
                    this.$notify({
                        type: 'error',
                        text: 'Ошибка отправки sms',
                    });
                }

                this.forms.sms.isSubmitting = false;
            },
            showHistory(id) {
                const index = this.history.openHistory.indexOf(id);
                if (index === -1) {
                    this.history.openHistory.push(id);
                } else {
                    this.history.openHistory.splice(index, 1);
                }
            },
            async setStatus() {
                this.forms.status.isLoading = true;

                let text = '';
                if (this.forms.status.status === 3 && this.forms.status.date) {
                    text = 'Позвонить ' + moment(this.forms.status.date).format('DD.MM.YYYY');
                }

                await Client.setStatus(this.client.id, this.forms.status.status, text);
                this.getStatusHistory();


                this.forms.status.isLoading = false;
            },
        },
        metaInfo() {
            return {
                title: 'Клиенты - редактирование',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
